import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

enum ProductType {
  Fix = 'FIX',
  Flex = 'FLEX',
}

interface OrderHistoryProductTypeProps {
  productType?: string
}

const useStyles = makeStyles()(theme => ({
  fixText: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: theme.shape.dayButton.size,
  },
  flexText: {
    color: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    borderRadius: theme.shape.dayButton.size,
  },
}))

/*
 * This component shows Fix/Flex for products of an order history detial modal
 */
const OrderHistoryProductType: React.FC<OrderHistoryProductTypeProps> = ({ productType }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  if (productType === ProductType.Fix) {
    return <Typography className={classes.fixText}>{t('shop.order-history.fix-label')}</Typography>
  }

  if (productType === ProductType.Flex) {
    return <Typography className={classes.flexText}>{t('shop.order-history.flex-label')}</Typography>
  }

  return null
}

export default OrderHistoryProductType
